import axios from "axios";

export const getHardwareModelsAPI = async params => {
  let response = await axios({
    url: `/api/v2/statistic/count-device-models`,
    method: "GET",
    params
  });
  const hardwareModels = response.data;
  return hardwareModels;
};
